import { Controller, useFormContext } from "react-hook-form";
import { MultiSelect } from "primereact/multiselect";

export const CustomMultiSelect = ({ name, options, placeholder }: any) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <MultiSelect
          {...field}
          className="w-full"
          options={options}
          placeholder={placeholder}
          display="chip"
        />
      )}
    />
  );
};
